import { render, staticRenderFns } from "./CopyToStallholderDialog.vue?vue&type=template&id=4902bdf3"
import script from "./CopyToStallholderDialog.vue?vue&type=script&lang=js"
export * from "./CopyToStallholderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports